import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo-group">
          <div className="logo-icon-container">
            <img src="/favicon.ico?v=2" alt="CrousRadar Logo" className="logo-img" />
          </div>
          <div className="logo-text-wrapper">
            <span className="logo-text default">CrousRadar</span>
            <span className="logo-text hover">Retour accueil</span>
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="nav-links">
          <Link to="/about" className="nav-link">Qui sommes-nous</Link>
          <Link to="/impact" className="nav-link">Notre impact</Link>
          <Link to="/blog" className="nav-link">Actu</Link>
          <Link to="/docs" className="nav-link">Docs</Link>
        </div>

        {/* CTA */}
        <div className="nav-cta-wrapper">
          <Link to="/etablissement" className="nav-btn secondary">
            Espace Établissement
          </Link>
          <a href="https://apps.apple.com/fr/app/crousradar/id6755202143" className="nav-btn primary">
            Obtenir l'App
          </a>
          <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Menu">
            {isMobileMenuOpen ? <X size={24} color="var(--text-main)" /> : <Menu size={24} color="var(--text-main)" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <Link to="/impact" className="mobile-nav-link" onClick={toggleMenu}>Notre impact</Link>
          <Link to="/about" className="mobile-nav-link" onClick={toggleMenu}>Qui sommes-nous</Link>
          <Link to="/blog" className="mobile-nav-link" onClick={toggleMenu}>Actu</Link>
          <Link to="/docs" className="mobile-nav-link" onClick={toggleMenu}>Documentation</Link>
          <Link to="/etablissement" className="mobile-nav-link" onClick={toggleMenu}>
            Espace Établissement
          </Link>
          <a href="https://apps.apple.com/fr/app/crousradar/id6755202143" className="mobile-nav-btn primary" onClick={toggleMenu}>
            Obtenir l'App
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;